import React, { useState, useEffect } from "react";
import {
  RefreshCw,
  AlertCircle,
  CheckCircle,
  Clock,
  XCircle,
  ArrowLeft,
} from "lucide-react";
import { Modal, ModalBody, ModalFooter } from "../Modal/MainModal";
import JoiningReportForm from "./JoinigReportForm";
import PersonalDataForm from "./E-Form";
import GratuityNominationForm, { FormF } from "./NewFormF";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import IDCardForm from "./IDCardForm";
import { Toast, useToast } from "./HROnboardingPanel";
import EPFForm11 from "./PFForm11";

const ApplicationTracker = ({ eid, setEid, Name }) => {
  console.log(eid);
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastFetch, setLastFetch] = useState(null);
  const navigate = useNavigate();
  const { logout } = useAuth();
  console.log(applications)

  // API function to fetch application data
  const fetchApplicationData = async (eid) => {
    const response = await fetch(
      `${process.env.REACT_APP_PUBLIC_API_BASE_URL}/v1/emp-documnets/get-filled-application?eid=${eid}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json(); // parse FastAPI error body
      const message =
        errorData?.detail ||
        `Failed to fetch applications: ${response.status} ${response.statusText}`;

      if (response.status === 401) {
        logout();
        navigate("/login");
      }
      throw new Error(message);
    }

    const data = await response.json();

    // Transform the API response to match our component structure
    return data.applications.map((app) => ({
      id: app._id,
      eid: app.eid,
      applicationId: app.applicationId,
      formType: app.formType,
      status: app.status || "submitted",
      submissionDate: app.submissionDate,
      data: app.data,
      approved: app.approved,
    }));
  };

  // Helper functions to extract data from different form types
  const getEmployeeName = (app) => {
    if (app.formType === "personal" && app.personalInfo) {
      return `${app.personalInfo.firstName} ${app.personalInfo.middleName} ${app.personalInfo.surname}`.trim();
    }
    if (app.employeeName) return app.employeeName;
    if (app.data && app.data.employeeName) return app.data.employeeName;
    return "N/A";
  };

  const getEstablishmentName = (app) => {
    if (app.establishmentName) return app.establishmentName;
    if (app.data && app.data.establishmentName)
      return app.data.establishmentName;
    return "N/A";
  };

  const getDepartment = (app) => {
    if (app.employeeDetails && app.employeeDetails.department)
      return app.employeeDetails.department;
    if (app.data && app.data.department) return app.data.department;
    return "N/A";
  };

  const getPosition = (app) => {
    if (app.employeeDetails && app.employeeDetails.postHeld)
      return app.employeeDetails.postHeld;
    if (app.data && app.data.position) return app.data.position;
    return "N/A";
  };

  const getContactInfo = (app) => {
    if (app.formType === "personal" && app.contactInfo) {
      return {
        email: app.contactInfo.email,
        mobile: app.contactInfo.mobile,
        city: app.contactInfo.presentCity,
      };
    }
    return { email: "N/A", mobile: "N/A", city: "N/A" };
  };

  const loadApplications = async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await fetchApplicationData(eid);
      setApplications(data);
      setLastFetch(new Date());
    } catch (err) {
      setApplications([]);
      setError(err.message);
      console.error("Error fetching applications:", err);
    } finally {
      setLoading(false);
    }
  };

  // Load data on component mount
  useEffect(() => {
    loadApplications();
  }, [eid]);

  const getStatusIcon = (status) => {
    switch (status.toLowerCase()) {
      case "submitted":
        return <CheckCircle className="w-4 h-4 text-green-500" />;
      case "pending":
        return <Clock className="w-4 h-4 text-yellow-500" />;
      case "under review":
        return <RefreshCw className="w-4 h-4 text-blue-500" />;
      case "approved":
        return <CheckCircle className="w-4 h-4 text-green-600" />;
      case "rejected":
        return <XCircle className="w-4 h-4 text-red-500" />;
      default:
        return <AlertCircle className="w-4 h-4 text-gray-500" />;
    }
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "submitted":
        return "bg-green-100 text-green-800 border-green-200";
      case "pending":
        return "bg-yellow-100 text-yellow-800 border-yellow-200";
      case "under review":
        return "bg-blue-100 text-blue-800 border-blue-200";
      case "approved":
        return "bg-green-100 text-green-800 border-green-200";
      case "rejected":
        return "bg-red-100 text-red-800 border-red-200";
      default:
        return "bg-gray-100 text-gray-800 border-gray-200";
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleBack = () => {
    // You can customize this to navigate to your desired route
    // For example, using React Router:
    // navigate('/dashboard')
    // or using window.history:
    setEid(null);
  };

  const statusCounts = applications.reduce((acc, app) => {
    const status = app.status.toLowerCase();
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedApplicationType, setSelectedApplicationType] = useState(null);

  const handleViewApplication = (application) => {
    setEid(application.eid);
    setSelectedApplicationType(application.formType);
    setIsModalOpen(true);
  };
  const { showToast, removeToast, toasts } = useToast();

  const approveApplication = async (eid, formType) =>{
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_PUBLIC_API_BASE_URL}/v1/employees/approve-application`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({ eid, formType }),
        }
      );
      if (!response.ok) {
        showToast("Failed to approve application", "error");
        return;
      }
      const data = await response.json();
      showToast("Application approved successfully!", "success");
    } catch (error) {
      console.error("Error approving application:", error);
      showToast("Error connecting to server. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  }

  const rejectApplication = async (eid, formType) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_PUBLIC_API_BASE_URL}/v1/employees/reject-application`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({ eid, formType }),
        }
      );
      if (!response.ok) {
        showToast("Failed to reject application", "error");
        return;
      }
      const data = await response.json();
      await loadApplications()
      showToast("Application rejected successfully!", "success");
    } catch (error) {
      console.error("Error rejecting application:", error);
      showToast("Error connecting to server. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  }

  const handleUpdate=async (refId, formType)=>{
    const empId = document.getElementById("EmployeeId")?.value;

    if(formType !== "Joining"){
      setLoading(true);
      await approveApplication(refId, formType)
      await loadApplications()
      setLoading(false);
      return;
    }
    if(!empId){
      showToast("Please enter employee ID", "error");
      return;
    }
    setLoading(true);
    try {
    const response = await fetch(
      `${process.env.REACT_APP_PUBLIC_API_BASE_URL}/v1/employees/update-employee-id?user_id=${refId}&employee_id=${empId}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        }
      }
    );
    if (!response.ok) {
      const errorData = await response.json(); // parse FastAPI error body
      const message =
        errorData?.detail ||
        `Failed to update applications: ${response.status} ${response.statusText}`;
      showToast(message, "error");
      return;
    }
    await approveApplication(empId, formType)
    const data = await response.json();
    showToast("Applications updated successfully!", "success");
    await loadApplications()
    } catch (error) {
      console.error("Error updating applications:", error);
      showToast("Error connecting to server. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
          {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
        />
      ))}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="View Application"
        size={"xl"}
      >
        <ModalBody>
          {selectedApplicationType === "Joining" && (
            <JoiningReportForm eid={eid} data={applications.filter(app => app.formType === "Joining")[0]?.data} />
          )}
          {selectedApplicationType === "Personal" && (
            <PersonalDataForm eid={eid} data={applications.filter(app => app.formType === "Personal")[0]?.data} />
          )}
          {selectedApplicationType === "Form F" && (
            <FormF eid={eid} data={applications.filter(app => app.formType === "Form F")[0]?.data} />
          )}
          {selectedApplicationType === "Gratuity Form" && (
            <GratuityNominationForm eid={eid} data={applications.filter(app => app.formType === "Gratuity Form")[0]?.data} />
          )}
          {selectedApplicationType === "ID Card" && (
            <IDCardForm eid={eid} data={applications.filter(app => app.formType === "ID Card")[0]?.data} />
          )}
          {selectedApplicationType === "EPF Form 11" && (
            <EPFForm11 eid={eid} data={applications.filter(app => app.formType === "EPF Form 11")[0]?.data} />
          )}
        </ModalBody>
        <ModalFooter>
          <button
            onClick={() => setIsModalOpen(false)}
            className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          {/* <button
            onClick={() => setIsModalOpen(false)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Got it
          </button> */}
        </ModalFooter>
      </Modal>

      <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <div className="flex justify-between items-center mb-6">
            <div className="flex items-center gap-4">
              <button
                onClick={handleBack}
                className="flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                Back
              </button>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">
                  Application Tracker
                </h1>
                <p className="text-gray-600 mt-1">
                  Track {Name} applications and their current status
                </p>
              </div>
            </div>
            <button
              onClick={loadApplications}
              disabled={loading}
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              <RefreshCw
                className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
              />
              Refresh
            </button>
          </div>

          {/* Status Summary */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            {["submitted", "pending", "under review", "approved"].map(
              (status) => (
                <div
                  key={status}
                  className="bg-gray-50 rounded-lg p-4 text-center"
                >
                  <div className="flex justify-center mb-2">
                    {getStatusIcon(status)}
                  </div>
                  <div className="text-2xl font-bold text-gray-900">
                    {statusCounts[status.toLowerCase()] || 0}
                  </div>
                  <div className="text-sm text-gray-600 capitalize">
                    {status}
                  </div>
                </div>
              )
            )}
          </div>

          {/* Last Updated */}
          {lastFetch && (
            <div className="text-sm text-gray-500 mb-4">
              Last updated: {lastFetch.toLocaleString()}
            </div>
          )}
        </div>

        {/* Error Message */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <div className="flex items-center gap-2">
              <AlertCircle className="w-5 h-5 text-red-500" />
              <span className="text-red-700">{error}</span>
            </div>
          </div>
        )}

        {/* Loading State */}
        {loading && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
            <div className="flex items-center justify-center">
              <RefreshCw className="w-6 h-6 animate-spin text-blue-500 mr-3" />
              <span className="text-gray-600">Loading application data...</span>
            </div>
          </div>
        )}

        {/* Applications List */}
        {!loading && applications.length > 0 && (
          <div className="space-y-4">
            {applications.map((app) => (
              <div
                key={app.id}
                className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <div
                      className="flex items-center gap-3 mb-2 underline cursor-pointer hover:text-blue-600 hover:underline"
                      onClick={() => handleViewApplication(app)}
                    >
                      <h3 className="text-lg font-semibold text-gray-900">
                        {app.formType} - {app.applicationId}
                      </h3>
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-medium border ${getStatusColor(
                          app.status
                        )}`}
                      >
                        {app.status.charAt(0).toUpperCase() +
                          app.status.slice(1)}
                      </span>
                    </div>
                    {/* <div className="text-gray-600 mb-2">
                    <span className="font-medium">{app.employeeName}</span>
                    {app.establishmentName !== 'N/A' && (
                      <span> • {app.establishmentName}</span>
                    )}
                  </div> */}
                    {app.department !== "N/A" && (
                      <div className="text-sm text-gray-600 mb-1">
                        Department: {app.department}
                        {app.position !== "N/A" &&
                          ` • Position: ${app.position}`}
                      </div>
                    )}
                    {app.contactInfo && app.contactInfo.email !== "N/A" && (
                      <div className="text-sm text-gray-600 mb-1">
                        Email: {app.contactInfo.email}
                        {app.contactInfo.mobile !== "N/A" &&
                          ` • Mobile: ${app.contactInfo.mobile}`}
                      </div>
                    )}
                    <div className="text-sm text-gray-500">
                      Submitted: {formatDate(app.submissionDate)}
                    </div>
                    <div className="flex items-center gap-2">
                   {app.approved?<div className="flex items-center gap-2 text-green-500 font-bold text-lg">Approved</div>: <div className="flex items-center gap-2">{app.formType==='Joining'&&<div className="flex items-center gap-2"><input type="text" id="EmployeeId" className="px-4 py-2 border border-gray-200 rounded-lg" placeholder="Update Employee ID" /></div>} <button onClick={()=>handleUpdate(app.eid, app.formType)} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">Approve</button></div>}
                   {<div className="flex items-center gap-2"><button onClick={()=>rejectApplication(app.eid, app.formType)} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">Reject</button></div>}
                   </div>
                  </div>
                  <div className="flex items-center">
                    {getStatusIcon(app.status)}
                  </div>
                </div>

                <div className="text-xs text-gray-400">
                  Employee Id: {app.eid} • Application ID: {app.applicationId} •
                  Form Type: {app.formType}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Empty State */}
        {!loading && applications.length === 0 && !error && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
            <AlertCircle className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              No Applications Found
            </h3>
            <p className="text-gray-600 mb-4">
              No employee applications available for this EID.
            </p>
            <button
              onClick={loadApplications}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Try Again
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ApplicationTracker;